/***
*
*   ACCOUNT HIERARCHY
*   Enables an admin to manage the account hierarchy in their application
*
**********/

import React, { Fragment, useContext, useState, useEffect } from 'react';
// Components import.
import { ViewContext, Card, AccountNav, Table, Button, Animate, TitleRow, useAPI } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import Styles from './account.module.scss'

export function AccountHierarchy(props) {

    const context = useContext(ViewContext);
    const bUData = useAPI('/api/lms/account/bu');
    const deptData = useAPI('api/lms/bu/departments');
    const [buName, setBuName] = useState([]);
    const [deptName, setDeptName] = useState([]);


    function addBusinessUnit() {

        context.modal.show({
            title: props.t('account.hierarchy.form.createBu.title'),
            form: {
                bu_name: {
                    label: props.t('account.hierarchy.form.createBu.buName.label'),
                    type: 'text',
                    required: true,
                    errorMessage: props.t('account.hierarchy.form.createBu.buName.error'),
                },
            },
            buttonText: props.t('account.hierarchy.form.createBu.button'),
            text: props.t('account.hierarchy.form.createBu.info'),
            url: '/api/lms/account/bu',
            method: 'POST',

        }, (form, response) => {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        });
    }

    function addDepartment() {

        context.modal.show({
            title: props.t('account.hierarchy.form.createDept.title'),
            form: {
                dept_name: {
                    label: props.t('account.hierarchy.form.createDept.deptName.label'),
                    type: 'text',
                    required: true,
                    errorMessage: props.t('account.hierarchy.form.createDept.deptName.error'),
                },
                bu_id: {
                    label: props.t('account.hierarchy.form.createDept.buId.label'),
                    type: 'select',
                    options: buName?.map(item => ({
                        label: item.bu_name,
                        value: item.id
                    })),
                    required: true,
                    errorMessage: props.t('account.hierarchy.form.createDept.buId.error'),
                },
            },
            buttonText: props.t('account.hierarchy.form.createDept.button'),
            text: props.t('account.hierarchy.form.createDept.info'),
            url: '/api/lms/bu/departments',
            method: 'POST',

        }, (form, response) => {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        });
    }

    // delete Business Units
    function deleteBUs(data) {
        try {
            // Check if the data is an array.
            const multi = Array.isArray(data);
            // Ensure that all details are in array format.
            const bUIds = multi ? data.map(item => item?.row?.id) : [data.id];
            (
                context.modal.show({
                    title: props.t('account.hierarchy.form.deleteBUs.title'),
                    form: {
                        bUIds: {
                            type: 'hidden',
                            value: bUIds,
                        }
                    },
                    buttonText: props.t('account.hierarchy.form.deleteBUs.button'),
                    text: props.t('account.hierarchy.form.deleteBUs.info'),
                    url: '/api/lms/account/bu',
                    method: 'DELETE',
                }, (form, response) => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);

                    if (response) {
                        window.location.href = response;
                    }
                })

            )
        }
        catch (err) {
            context.handleError(err);
        }
    }

    // delete Departments
    function deleteDepartments(data) {
        try {
            // Check if the data is an array.
            const multi = Array.isArray(data);
            // Ensure that all details are in array format.
            const deptIds = multi ? data.map(item => item?.row?.id) : [data.id];
            (
                context.modal.show({
                    title: props.t('account.hierarchy.form.deleteDepartments.title'),
                    form: {
                        deptIds: {
                            type: 'hidden',
                            value: deptIds,
                        }
                    },
                    buttonText: props.t('account.hierarchy.form.deleteDepartments.button'),
                    text: props.t('account.hierarchy.form.deleteDepartments.info'),
                    url: 'api/lms/bu/departments',
                    method: 'DELETE',
                }, (form, response) => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);

                    if (response) {
                        window.location.href = response;
                    }
                })

            )
        }
        catch (err) {
            context.handleError(err);
        }
    }

    // eslint-disable-next-line no-unused-vars
    function editBusinessUnit(data, callback) {

        context.modal.show({
            title: props.t('account.hierarchy.form.editBU.title'),
            form: {
                bu_name: {
                    label: props.t('account.hierarchy.form.editBU.buName.label'),
                    type: 'text',
                    required: true,
                    value: data.bu_name,
                    errorMessage: props.t('account.hierarchy.form.editBU.buName.error')
                }
            },
            buttonText: props.t('account.hierarchy.form.editBU.button'),
            url: `/api/lms/account/bu/${data.id}`,
            method: 'PATCH'

        }, (res) => {

            context.notification.show(data.bu_name + props.t('account.hierarchy.form.editBU.notification'), 'success', true);
            callback(res);
            setTimeout(() => {
                window.location.reload();
            }, 1000);

        });
    }

    function editDepartment(data, callback) {

        context.modal.show({
            title: props.t('account.hierarchy.form.editDept.title'),
            form: {
                dept_name: {
                    label: props.t('account.hierarchy.form.editDept.deptName.label'),
                    type: 'text',
                    required: true,
                    value: data?.dept_name,
                    errorMessage: props.t('account.hierarchy.form.editDept.deptName.error')
                },
                bu_id: {
                    label: props.t('account.hierarchy.form.editDept.buId.label'),
                    type: 'select',
                    default: data?.bu_id,
                    options: buName?.map(item => ({
                        label: item.bu_name,
                        value: item.id
                    })),
                    required: true,
                    errorMessage: props.t('account.hierarchy.form.editDept.buId.error'),
                },
            },
            buttonText: props.t('account.hierarchy.form.editDept.button'),
            url: `api/lms/bu/departments/${data.id}`,
            method: 'PATCH'

        }, (res) => {

            context.notification.show(data?.dept_name + props.t('account.hierarchy.form.editDept.notification'), 'success', true);
            callback(res);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        });
    }

    function deleteBusinessUnit(data, callback) {

        context.modal.show({
            title: props.t('account.hierarchy.form.deleteBU.title'),
            form: {},
            buttonText: props.t('account.hierarchy.form.deleteBU.button'),
            text: props.t('account.hierarchy.form.deleteBU.info', { buName: data.bu_name }),
            url: `/api/lms/account/bu/${data.id}`,
            method: 'DELETE',
            destructive: true

        }, () => {

            context.notification.show(data.bu_name + props.t('account.hierarchy.form.deleteBU.notification'), 'success', true);
            callback();
            setTimeout(() => {
                window.location.reload();
            }, 1000);

        });
    }

    function deleteDepartment(data, callback) {

        context.modal.show({
            title: props.t('account.hierarchy.form.deleteDept.title'),
            form: {},
            buttonText: props.t('account.hierarchy.form.deleteDept.button'),
            text: props.t('account.hierarchy.form.deleteDept.info', { deptName: data.dept_name }),
            url: `api/lms/bu/departments/${data.id}`,
            method: 'DELETE',
            destructive: true

        }, () => {

            context.notification.show(data.dept_name + props.t('account.hierarchy.form.deleteDept.notification'), 'success', true);
            callback();

        });
    }

    useEffect(() => {
        if (bUData) {
            setBuName(bUData?.data || [])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bUData]);

    useEffect(() => {
        if (deptData) {
            setDeptName(deptData?.data || []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deptData]);

    const businessActions = {
        edit: editBusinessUnit,
        delete: deleteBusinessUnit,
    }

    const departmentActions = {
        edit: editDepartment,
        delete: deleteDepartment,
    }
    // const message = {
    //     type: "info",
    //     title: "Managing Business Units",
    //     closable: true,
    //     text: "Add users by inviting them here. Licenses are charged per scholar. If a scholar for whom a subscription has not been purchased yet is added, the account will be disabled until payment is completed for the pending invoice. Each account can also have one billing and one admin account."
    // }
    return (
        <Fragment>
            {(bUData?.loading && deptData?.loading) ?
                <LoadingBackdrop isOpen={true} /> :
                <>
                    <AccountNav />
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <Animate>
                            <TitleRow title={props.t('account.hierarchy.form.manageBU.title')}>
                                <div style={{ display: "flex", gap: "0.7em" }}>
                                    <Button small text={props.t('account.hierarchy.form.manageBU.button')} action={addBusinessUnit} />
                                </div>
                            </TitleRow>

                            <Card className={Styles.cardContainer}>
                                <Table
                                    search
                                    selectable
                                    className='restrict-width'
                                    data={buName}
                                    loading={bUData?.loading}
                                    show={['bu_name']}
                                    actions={businessActions}
                                    bulkActions={{
                                        custom: [{ text: props.t('account.hierarchy.form.manageBU.table.deleteButton'), color: "orange", action: deleteBUs }]
                                    }}
                                    translation='account.hierarchy.form.manageBU.table'

                                />
                            </Card>
                        </Animate>
                        <Animate>
                            <TitleRow title={props.t('account.hierarchy.form.manageDept.title')}>
                                <div style={{ display: "flex", gap: "0.7em" }}>
                                    <Button small text={props.t('account.hierarchy.form.manageDept.button')} action={addDepartment} />
                                </div>
                            </TitleRow>

                            <Card className={Styles.cardContainer}>
                                <Table
                                    search
                                    selectable
                                    className='restrict-width'
                                    data={deptName}
                                    loading={deptData?.loading}
                                    show={['dept_name', 'bu_name']}
                                    actions={departmentActions}
                                    bulkActions={{
                                        custom: [{ text: props.t('account.hierarchy.form.manageDept.table.deleteButton'), color: "orange", action: deleteDepartments }]
                                    }}
                                    translation='account.hierarchy.form.manageDept.table'
                                />
                            </Card>
                        </Animate>
                    </div>
                </>
            }
        </Fragment>
    );
}
